// YARN
import { Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

// SERVICES
import dropletLogo from 'assets/images/laissez-tomber.png';
import logoCover from 'assets/images/logo-cover.png';
import logoCoverTransparent from 'assets/images/logo-cover-transparent.png';
import logoCoverDarkGreen from 'assets/images/logo-cover-dark-green.png';
import { StyledTooltip } from 'utils/Datagrid/CustomGenericDataGridUtils';
import bioLogo from 'assets/images/bio.png';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

const CultureItem = ({ culture, isOrganicState, isCover, hasSplittedCulture }) => {
  return (
    <div className="cell-main-content content-with-surface">
      <div className="infos">
        {hasSplittedCulture && (
          <div className="surface">
            <span>{Number(culture.surface.toFixed(2))}</span>
          </div>
        )}

        <div className={culture.type === 'intermediate' ? 'intermediate' : ''}>{culture.name}</div>
      </div>
      <div className="cultures-icons-wrapper">
        {culture.irrigation > 0 && (
          <div className="culture-infos-icon">
            <img src={dropletLogo} alt="Logo irrigation" className="dropletLogo" />
          </div>
        )}
        {isCover && (
          <div className="culture-infos-icon">
            <StyledTooltip
              title={`${
                culture?.cover === 'POSSIBLE'
                  ? 'Autre couvert possible avant la culture'
                  : culture?.cover === 'LEGUME'
                    ? 'Couvert à base légumineuse avant la culture'
                    : culture?.cover === 'OTHER'
                      ? 'Couvert à base non légumineuse avant la culture'
                      : ''
              }`}
              placement="top"
            >
              <img
                src={
                  culture?.cover === 'POSSIBLE'
                    ? logoCoverTransparent
                    : culture?.cover === 'LEGUME'
                      ? logoCover
                      : culture?.cover === 'OTHER'
                        ? logoCoverDarkGreen
                        : null
                }
                alt="Logo couvert"
                className="dropletLogo"
              />
            </StyledTooltip>
          </div>
        )}
        {isOrganicState && (
          <div className="culture-infos-icon">
            <StyledTooltip
              title={`${
                culture?.organicState === 'conversion'
                  ? 'Culture bio en conversion'
                  : culture?.organicState === 'organic'
                    ? 'Culture bio'
                    : ''
              }`}
              placement="top"
            >
              {culture?.organicState === 'conversion' ? (
                <SyncAltIcon className="dropletLogo" />
              ) : culture?.organicState === 'organic' ? (
                <img src={bioLogo} alt="Logo organic" className="dropletLogo" />
              ) : null}
            </StyledTooltip>
          </div>
        )}
      </div>
    </div>
  );
};

const Parcel = ({ cultures, indices, hasSplittedCulture, isEdited, onSelect }) => {
  const hasEditedCulture = indices.some((idx) => isEdited(idx));

  return (
    <Box
      className={`cell-box cell-box-multiple ${hasEditedCulture ? 'MuiCell--editing' : ''}`}
      onClick={() => onSelect(indices[0])}
    >
      <div className="cell-multiple-cultures">
        {cultures.map((culture, i) => {
          const isCover =
            culture?.cover === 'POSSIBLE' ||
            culture?.cover === 'LEGUME' ||
            culture?.cover === 'OTHER';
          const isOrganicState =
            culture?.organicState === 'conversion' || culture?.organicState === 'organic';

          return (
            <div key={indices[i]} className="cell-culture-row">
              <CultureItem
                culture={culture}
                isOrganicState={isOrganicState}
                isCover={isCover}
                hasSplittedCulture={hasSplittedCulture}
              />
            </div>
          );
        })}
      </div>
      <EditIcon className="custom-edit-parcelSynthesis" sx={{ padding: '0px !important' }} />
    </Box>
  );
};

export default Parcel;
